

export class GeoFenceByCompanyAndBranchOutput implements IGeoFenceByCompanyAndBranchOutput {
    /** The auto-generated id of the geofence master */
    geofence_id!: number;
    /** The place name with 255 character limit */
    name!: string;

    constructor(data?: IGeoFenceByCompanyAndBranchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofence_id = _data["geofence_id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GeoFenceByCompanyAndBranchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeoFenceByCompanyAndBranchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofence_id"] = this.geofence_id;
        data["name"] = this.name;
        return data; 
    }
}

export interface IGeoFenceByCompanyAndBranchOutput {
    /** The auto-generated id of the geofence master */
    geofence_id: number;
    /** The place name with 255 character limit */
    name: string;
}

